import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { VisitcountListData } from 'src/app/hist/models/visitcount-report';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { HcrService } from 'src/app/services/hcr-service.service';
import { LocalPrintService } from 'src/app/services/local-print.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';

@Component({
  selector: 'app-visitcount-list',
  templateUrl: './visitcount-list.component.html',
  styleUrls: ['./visitcount-list.component.css']
})

export class VisitcountListComponent implements OnInit, AfterViewInit {

  constructor(
      private localPrintService: LocalPrintService,
      private hcrService: HcrService,
      private notification: EasyNotificationService) {
      }
  @ViewChild('reportContainer', { static: false }) reportContainer: ElementRef<HTMLDivElement>;


  reportName = '門診診療次數明細表';
  sizePage = {
    width: 28.7, //cm
    height: 20 //cm
  };
  paddingPage = {
    top: -0.5, // cm
    right: 0, // cm
    bottom: 0.2, // cm
    left: 0 // cm
  };
  heightPageWithoutPadding = this.convertCmtoPx(
    this.sizePage.height - (this.paddingPage.top + this.paddingPage.bottom)
  ) - 30;

  forExcel = true;
  listItems: VisitcountListData[];  //data

  nowdateStr: string = '';  //印表日期
  nowtimeStr: string = '';  //印表時間
  totalRecord: number = 0;  //總筆數
  _sDate: string = '';   //查詢期間起
  _eDate: string = '';   //查詢期間訖

  elContainer: HTMLElement;

  pageContent = [[]];     // Ex: [[0, 1, 2, 3], [4, 5]]
  upperboundIndex: number = 0;

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    var style = document.createElement('style');
      style.textContent =
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.pres-report2 table{ border:0px solid black; border-collapse: collapse; width: 100%; }\n' +
      '.pres-report2 table td, table th { border-bottom: 1px solid black; padding-left: 5px;padding-right: 5px; }\n' +
      '.pres-report2 table tr:first-child th { border-top: 0; vertical-align: bottom; padding: 0px }\n' +
      '.pres-report2 table tr:last-child td { border-bottom: 0; }\n' +
      '.pres-report2 table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
      '.pres-report2 table tr td:last-child, table tr th:last-child { border-right: 0; }\n' +
      '.content { overflow: visible; }\n' +
      '@page { size: A4 landscape; margin: 0.5cm 0.5cm; }\n';

      this.reportContainer.nativeElement.appendChild(style);
  }

  clearData() {
    if (this.elContainer)
      this.elContainer.innerHTML = '';
    const parentElement = document.getElementById("pres-report2");
    if (parentElement)
      parentElement.firstElementChild.innerHTML = '';
  }

  async exportAsExcel() {
    if (this.totalRecord > 0) {
      const table = this.reportContainer.nativeElement;
      await this.hcrService.ExportTableToExcel(this.reportName, table.innerHTML)
    } else {
      this.notification.showInfo('查無資料可供匯出!');
    }
  }

  async onPrint() {
    if (this.totalRecord > 0) {
      const printContents = this.getHtml();
      var ret = await this.localPrintService.printHtml(444, this.reportName, printContents);  // 'Consultation Volume Statistic'
      if (ret.Successed) {
        this.notification.showSuccess(this.reportName + '已送出列印!', true);
      } else {
        this.notification.showError(this.reportName + '送出列印失敗!');
      }
    } else {
      this.notification.showInfo('查無資料可供列印!');
    }
  }

  async fetchData(data: VisitcountListData[], forExcel = true, startDate: Date,endDate: Date) {
    this.forExcel = forExcel;
    this.elContainer = document.getElementById("container");

    //以下是報表表頭欄位
    this.nowdateStr = DateHelper.getROCDateStringWithSepetator(DateHelper.today);
    this.nowtimeStr = DateHelper.getTimeString(new Date(), ':', true);
    this._sDate = DateHelper.getROCDateStringWithSepetator(startDate);
    this._eDate = DateHelper.getROCDateStringWithSepetator(endDate);

    this.listItems = data;
    this.totalRecord = this.listItems.length;
    this.insertListData();
  }

  // #region 組報表
  // 組報表的html內容
  insertListData() {
    var html_Block = "";
    var iPage = 0;
    var iBlock = 0;
    this.elContainer.innerHTML = this.createHTMLPage(iPage);  // 整份報表的html內容
    var html_header = this.createHTMLPageHeader(iPage);       // 頁表頭
    var html_ListerHeader = this.createHTMLListHeader();      // List欄位顯示名稱
    var html_finish = this.createHTMLFinish();                // 報表結束 -- 以下空白

    //var html_total = this.createHTMLTotal();
    var totalRow = this.listItems.find(item => item.IsSummary === true);
    var html_total = totalRow ? this.createHTMLTotal(totalRow) : "";

    var html_blank = this.createHTMLBlankLine();
    var elPageContent = document.getElementById("page-" + iPage + "-content");  // 取得某頁的content，每次查詢後會取第0頁
    var prevTableContent: any;
    var afterSummary = false;

    // 組報表內容
    // [頁表頭][List欄位顯示名稱]
    elPageContent.innerHTML = html_header;
    var elTableContent = document.getElementById("table-" + iPage + "-content");
    elTableContent.innerHTML = html_ListerHeader;

    for (let i = 0; i < this.totalRecord; i++) {
      // 跳過總計行, 最後再添加
      if (this.listItems[i].IsSummary === true) {
        continue;
      }

      // 加入 List 每一筆的內容
      prevTableContent = elTableContent.innerHTML;
      if (afterSummary) {
        elTableContent.innerHTML += html_ListerHeader;
        afterSummary = false;
      }
      html_Block = this.createHTMLBlock(this.listItems[i]);

      elTableContent.innerHTML += html_Block;

      // 判斷是否超出頁面範圍? -> 新增一頁
      if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
        elTableContent.innerHTML = prevTableContent;
        iPage += 1;
        this.elContainer.innerHTML += this.createHTMLPage(iPage);
        elPageContent = document.getElementById("page-" + iPage + "-content");
        // [頁表頭][List欄位顯示名稱]
        html_header = this.createHTMLPageHeader(iPage);
        elPageContent.innerHTML += html_header;
        elTableContent = document.getElementById("table-" + iPage + "-content");
        elTableContent.innerHTML = html_ListerHeader;
        elTableContent.innerHTML += html_Block;

        this.pageContent[iPage] = [];
        this.pageContent[iPage].push(iBlock);
      } else {
        this.pageContent[iPage].push(iBlock);
      }

      // 報表畫面設計因素，如果遇到合計，後面要空一行再加入清單欄位表頭
      if ((this.listItems[i].IsSummary) && !(i == this.totalRecord - 1))
      {
        afterSummary = true;
        prevTableContent = elTableContent.innerHTML;
        elTableContent.innerHTML += html_blank;
        if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
          elTableContent.innerHTML = prevTableContent;
          iPage += 1;
          this.elContainer.innerHTML += this.createHTMLPage(iPage);
          elPageContent = document.getElementById("page-" + iPage + "-content");
          // [頁表頭][List欄位顯示名稱]
          html_header = this.createHTMLPageHeader(iPage);
          elPageContent.innerHTML += html_header;
          elTableContent = document.getElementById("table-" + iPage + "-content");
          elTableContent.innerHTML = html_ListerHeader;
          elTableContent.innerHTML += html_blank;

          this.pageContent[iPage] = [];
          this.pageContent[iPage].push(iBlock);
        } else {
          this.pageContent[iPage].push(iBlock);
        }
      }
      iBlock += 1;
    }

    // 在最後添加總計行
    if (totalRow) {
      prevTableContent = elTableContent.innerHTML;
      elTableContent.innerHTML += html_total;

      // 判斷是否超出頁面範圍? -> 新增一頁
      if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
          elTableContent.innerHTML = prevTableContent;
          iPage += 1;
          this.elContainer.innerHTML += this.createHTMLPage(iPage);
          elPageContent = document.getElementById("page-" + iPage + "-content");
          // [頁表頭][List欄位顯示名稱]
          html_header = this.createHTMLPageHeader(iPage);
          elPageContent.innerHTML += html_header;
          elTableContent = document.getElementById("table-" + iPage + "-content");
          //elTableContent.innerHTML = html_ListerHeader;
          elTableContent.innerHTML += html_total;

          this.pageContent[iPage] = [];
          this.pageContent[iPage].push(iBlock);
      } else {
          this.pageContent[iPage].push(iBlock);
      }
  }

    elPageContent.innerHTML += html_finish;
    this.upperboundIndex = iPage;

    for (var i = 0; i <= iPage; i++) {
      var totalPage = document.getElementById("totalPage-" + i);
      totalPage.innerHTML = (this.upperboundIndex + 1).toString();
    }
  }

  createHTMLFinish() {
    return `<div style="-webkit-text-size-adjust: none; font-size: 12pt;zoom: 0.8;margin: 10px 10px 0px 10px; text-align: center; border-top: 2px double black;">
                <label style="font-weight: bold;">以下空白</label>
            </div>`;
  }

  createHTMLPage(iPage) {
    return `
            <style>
              .excel-format {
                font-size: 14pt;
              }
              .excel-format-text {
                font-size: 14pt;
                mso-number-format: "@";
              }
            </style>
            <div class="page" id="page-` + iPage + `"
                style="
                margin: 0px auto;
                height: ` + this.sizePage.height + `cm;
                width: ` + this.sizePage.width + `cm;
                padding-top: ` + this.paddingPage.top + `cm;
                padding-right: ` + this.paddingPage.right + `cm;
                padding-bottom: ` + this.paddingPage.bottom + `cm;
                padding-left: ` + this.paddingPage.left + `cm;
                display: block;
                margin: 0px auto;
                box-shadow: 0 0 0.15cm rgba(0, 0, 0, 0.15);
                box-sizing: border-box;
                ">
                <div class="content" id="page-` + iPage + `-content">
                </div>
            </div>`;
  }

  createHTMLBlankLine() {
    return `<tr>
              <th colspan="29" style="height: 12px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
              </th>
            </tr>`;
  }

  createHTMLListHeader() {
    var commonStyle = 'border-top: none; border-bottom: none; font-size: 12pt';
      return `<tr>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          病歷號
        </th>
        <th style="text-align: center; width: 8%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          姓名
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          案類
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          卡號
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          日期
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          掛號
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          注射
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          復健
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          內服
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          檢查
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          手術
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          透析
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          外用
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          放射
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          診察
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          注技
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          處置
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          輸血
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          嬰兒
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          藥事
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          麻醉
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          病房
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          自費
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          特材
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          其他
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt;border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          自付
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          藥付
        </th>
        <th style="text-align: center; width: 3%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          檢付
        </th>
        <th style="text-align: center; width: 4%; font-size: 12pt; border-right: 0px solid black; border-left: 0px solid black; border-bottom: 2px double black; padding-bottom: 8px;">
          總額
        </th>
      </tr>
      <tr>
        <td colspan="29" style="height: 5px; border: none;"></td>
      </tr>`;
    }

  createHTMLPageHeader(iPage) {
    return `<div id="header" style="margin: 0px 20px;">
                <div style="display: flex;column-gap: 5px;">
                  <table style="width: 100%; text-align: center; border: none;">
                    <tr>
                      <td colspan="29" style="height: 30px; text-align: center; font-weight: bolder; font-size: 16pt; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                      ` + this.reportName + `
                      </td>
                    </tr>
                    <tr>
                        <td style="width: 33%; font-size: 12px; text-align: left; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                        印表日期 ` + this.nowdateStr + `
                        </td>
                        <td colspan="5" style="width: 34%; font-size: 12px; text-align: center; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                        期間：` + this._sDate + ` 至 ` + this._eDate + `
                        </td>
                        <td style="width: 33%; font-size: 12px; text-align: right; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                        總筆數 ` + (this.totalRecord > 0 ? (this.listItems.some(item => item.IsSummary) ? this.totalRecord - 1 : this.totalRecord) : 0) + `
                        </td>
                    </tr>
                        <td style="font-size: 12px; text-align: left; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                        印表時間 ` + this.nowtimeStr + `
                        </td>
                        <td colspan="5" style="font-size: 12px; text-align: center; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                        </td>
                        <td style="font-size: 12px; text-align: right; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                        頁 ` + (iPage + 1) + `/<span id="totalPage-` + iPage + `"></span>
                        </td>

                    </tr>
                  </table>
                </div>
              </div>
              <div style="-webkit-text-size-adjust: none; font-size: 12pt;zoom: 0.8;margin: 0px 10px; text-align: center;">
                  <label style="font-weight: bold; height: 23px;">　</label>
              </div>
              <div style="-webkit-text-size-adjust: none; font-size: 12px;zoom: 0.8;margin: 0px 10px;">
                  <div style="display: flex;column-gap: 5px;">
                      <table id="table-` + iPage + `-content" style="width: 100%; font-size: 12pt; text-align: center; border: none; line-height: 0.5;">
                      </table>
                  </div>
              </div>`;
  }

  createHTMLBlock(data: VisitcountListData) {
    var commonStyle = 'border-top: none; border-bottom: none; font-size: 12pt';
    var commonClassText = this.forExcel ? 'class="excel-format-text"' : '';

      // 格式化日期
      const visitDate = data.VisitDate ? new Date(data.VisitDate) : new Date();
      const formattedDate = DateHelper.getROCFullDateString(visitDate);

      return `
        <tr>
          <td style="text-align: left; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.PatientNo}</td>
          <td style="text-align: left; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.PatientName}</td>
          <td style="text-align: left; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.Case}</td>
          <td style="text-align: left; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.Isqno}</td>
          <td style="text-align: left; padding-top: 10px; ${commonStyle}" ${commonClassText}>${formattedDate}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.FeeReg == 0 ? "" : data.FeeReg}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ARx4 == 0 ? "" : data.ARx4}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx8 == 0 ? "" : data.ATx8}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ARx2 == 0 ? "" : data.ARx2}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx6 == 0 ? "" : data.ATx6}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx10 == 0 ? "" : data.ATx10}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx14 == 0 ? "" : data.ATx14}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ARx3 == 0 ? "" : data.ARx3}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx7 == 0 ? "" : data.ATx7}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ADx == 0 ? "" : data.ADx}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx5 == 0 ? "" : data.ATx5}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx9 == 0 ? "" : data.ATx9}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx13 == 0 ? "" : data.ATx13}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx17 == 0 ? "" : data.ATx17}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.AMed == 0 ? "" : data.AMed}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx11 == 0 ? "" : data.ATx11}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.ATx15 == 0 ? "" : data.ATx15}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.AOwn == 0 ? "" : data.AOwn}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.AMat == 0 ? "" : data.AMat}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.AOther == 0 ? "" : data.AOther}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.APartOPD == 0 ? "" : data.APartOPD}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.APartRx == 0 ? "" : data.APartRx}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.APartExam == 0 ? "" : data.APartExam}</td>
          <td style="text-align: right; padding-top: 10px; ${commonStyle}" ${commonClassText}>${data.TotalAmount == 0 ? "" : data.TotalAmount}</td>
        </tr>`;
  }

  createHTMLTotal(data: VisitcountListData) {
    var commonClassText = this.forExcel ? 'class="excel-format-text"' : '';
      return `
      <tr>
      <td colspan="29" style="height: 8px; border: none;"></td>
      </tr>
      <tr>
        <td colspan="5" style="font-size: 12pt; font-weight: bold; text-align: left; padding-top: 10px ; border-top: 2px solid black;">總計：</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.FeeReg}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ARx4}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx8}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ARx2}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx6}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx10}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx14}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ARx3}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx7}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ADx}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx5}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx9}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx13}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx17}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.AMed}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx11}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.ATx15}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.AOwn}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.AMat}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.AOther}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.APartOPD}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.APartRx}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.APartExam}</td>
        <td style="text-align: right; padding-top: 10px; border-top: 2px solid black; font-size: 12pt">${data.TotalAmount}</td>
      </tr>`;
  }

  getHtml() {
    var html = this.reportContainer.nativeElement.innerHTML;
    for (var i = 0; i <= this.upperboundIndex; i++) {
      html = html.replace('box-shadow: 0 0 0.15cm rgba(0, 0, 0, 0.15);', '');
    }
    return html;
  }
  //#endregion

  convertPxToCm(px) {
    return Math.round(((px * 2.54) / 96) * 100) / 100;
  }

  convertCmtoPx(cm) {
    return Math.round((cm * 96) / 2.54);
  }

}
